(() => {
  class MailOrderTableController {
    constructor(ngDialog) {
      'ngInject';

      Object.assign(this, {
        ngDialog
      });
    }

    callRejectModal(visit) {
      return this.ngDialog.open({
        templateUrl: 'app/components/update-mailorder-status/mailorder-status-update.html',
        controller: 'MailOrderStatusUpdateController',
        controllerAs: 'statusupdate',
        data: {
          visit
        }
      });
    }

    getMailOrderInfo(visit) {
      return this.ngDialog.open({
        templateUrl: 'app/components/mailorder-info/mailorder-info.html',
        controller: 'MailOrderInfoController',
        controllerAs: 'mailorderinfo',
        className: 'ngdialog-theme-default mailorder-modal',
        data: {
          visit
        }
      });
    }

  }

  MailOrderTableController.$inject = ["ngDialog"];
  angular.module('pims').component('mailorderTable', {
    templateUrl: 'app/components/mailorder-table/mailorder-table.html',
    controller: MailOrderTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      mailordervisits: '<'
    }
  });
})();